export default "__VITE_ASSET__BkL4Lnr5__"